/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSearchFilterConfigRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getSearchFilterConfig',
  auth: 'external',
  fingerprint: '4oEIKcmmEbnaLGZWpyXwopwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPaginatedSearchFilterOptionsRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getPaginatedSearchFilterOptions',
  auth: 'external',
  fingerprint: 'unUTtSH07dxhw7xxqkaQ-ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBatchSearchFilterOptionsRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getBatchSearchFilterOptions',
  auth: 'external',
  fingerprint: 'AvGlt1OjWd22IKdH54SN-JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};